import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface CreateBusinessInsightCriteria {
    dashboardId: string;
    type: string;
}

class CreateBusinessInsightCriteriaImpl implements CreateBusinessInsightCriteria {
    constructor(readonly dashboardId: string, readonly type: string) {}
}

export class CreateBusinessInsightCriteriaBuilder {
    private dashboardId: Option<string> = none;

    private type: Option<string> = none;

    static create = (): CreateBusinessInsightCriteriaBuilder => new CreateBusinessInsightCriteriaBuilder();

    withDashboardId = (dashboardId: string): CreateBusinessInsightCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    withType = (type: string): CreateBusinessInsightCriteriaBuilder => {
        this.type = some(type);
        return this;
    };

    build = (): CreateBusinessInsightCriteria => {
        if (isNone(this.dashboardId) || isNone(this.type)) {
            throw new ReferenceError('Undefined prop');
        }

        return new CreateBusinessInsightCriteriaImpl(this.dashboardId.value, this.type.value);
    };
}
